import { useState, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useSpeechSynthesisConfig } from '@provider/speech-synthesis';
import { SpeechButton } from '@ui/kit';
import { useToggleState, CSSRefTransition } from '@utils/react';
import { AudioButton } from './atom.audio-button.js';
import { toolsTransition, postloadedToolbarTransitionDurationMs, playerWrapper, PLAYER_TRANSITION_DURATION_MS, toolbarCls } from './molecule.toolbar.style.js';
import { selectors } from './organism.content.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { AudioPlayer } from './audio-player/audio-player.js';

function Toolbar(props) {
  const speechConfig = useSpeechSynthesisConfig();
  const speechFile = usePostloadedOption(props.speechFile);
  const extraButtons = usePostloadedOption(props.extraButtons);
  const disableToolbar = usePostloadedOption(props.disableToolbar);
  const [playbackActive, playbackActions] = useToggleState(false);
  const showToolbar = speechFile !== undefined && disableToolbar !== undefined && disableToolbar !== true;
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: showToolbar && /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: postloadedToolbarTransitionDurationMs,
      classNames: toolsTransition,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: toolsTransition,
        children: /*#__PURE__*/jsxs(Fragment, {
          children: [props.speechFile && /*#__PURE__*/jsx(TransitionGroup, {
            component: null,
            appear: true,
            children: playbackActive && /*#__PURE__*/jsx(CSSRefTransition, {
              timeout: PLAYER_TRANSITION_DURATION_MS,
              classNames: playerWrapper,
              children: ref => /*#__PURE__*/jsx("div", {
                ref: ref,
                className: playerWrapper,
                children: /*#__PURE__*/jsx(AudioPlayer
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                , {
                  src: speechFile,
                  onEnd: playbackActions.disable
                })
              })
            }, "audioPlayer")
          }), /*#__PURE__*/jsx("div", {
            className: toolbarCls,
            onClick: stopEventPropagation,
            children: /*#__PURE__*/jsxs("ul", {
              children: [extraButtons, speechConfig.enabled && !speechFile && /*#__PURE__*/jsx("li", {
                children: !speechFile ? /*#__PURE__*/jsx(SpeechButton, {
                  rootSelector: selectors.container(),
                  defaultTooltip: "Læs op",
                  hideWhenEmpty: true,
                  forceVisibleLangaugeSelector: true
                }) : /*#__PURE__*/jsx(AudioButton, {
                  enabled: playbackActive,
                  toggleState: playbackActions.toggle,
                  speechSynthesisRootSelector: selectors.container()
                })
              }), speechFile && /*#__PURE__*/jsx("li", {
                children: /*#__PURE__*/jsx(AudioButton, {
                  enabled: playbackActive,
                  toggleState: playbackActions.toggle,
                  speechSynthesisRootSelector: selectors.container()
                })
              })]
            })
          })]
        })
      })
    })
  });
}
function stopEventPropagation(evt) {
  evt.stopPropagation();
}
function usePostloadedOption(unresolvedContent) {
  const [content, setContent] = useState(unresolvedContent instanceof Promise ? undefined : typeof unresolvedContent === "undefined" ? null : unresolvedContent);
  useEffect(() => {
    if (unresolvedContent instanceof Promise) {
      unresolvedContent.then(speechFile => setContent(speechFile ?? null));
    }
  }, [unresolvedContent]);
  return content;
}

export { Toolbar };
//# sourceMappingURL=molecule.toolbar.js.map
